import { MenuItem, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../context";

// ----------------------------------------------------------------------

export default function CreateAppItem() {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	const onClick = () => {
		actions.hideSelectAppMenu();
		actions.showAddNewAppDialog();
	};

	return (
		<MenuItem onClick={onClick}>
			<Stack flexDirection={"row"} alignItems={"center"} gap={1}>
				<Iconify icon='material-symbols:add' ml='auto' width={20} />
				<Typography variant='subtitle2'>{translate("nav_app_section.create_app")}</Typography>
			</Stack>
		</MenuItem>
	);
}
